import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import {
  color, display, spacing, typography,
} from '../styled-system';
import {
  alertTypeStyle, sizeDefault, textOverflow, typographyVariant,
} from './config';

export const StyledTypography = styled.p`
  font-family: 'Lato';
  display: block;

  ${({ type, size }) => typographyVariant[type]?.[size] || typographyVariant[type]?.[sizeDefault[type]]}
  ${({ underline }) => underline && { textDecoration: 'underline' }}
  ${({ italic }) => italic && { fontStyle: 'italic' }}
  ${({ bold }) => bold && { fontWeight: 700 }}
  ${({ type, alertType }) => {
    switch (type) {
      case 'alert':
        return alertTypeStyle[alertType];
      default:
        return {};
    }
  }}
  ${({ overflow }) => textOverflow[overflow || 'newline']}
  ${
  /**
     * ellipsis/clamp utilities, will show ellipsis in selected line number
     * @param {{ clamp: number }} props
     * @returns
     */
  ({ clamp }) => clamp
      && css`
        display: -webkit-box;
        -webkit-line-clamp: ${clamp};
        -webkit-box-orient: vertical;
        overflow: hidden;
      `
}
  ${typography}
  ${color}
  ${display}
  ${spacing}
`;

export const AutoScroll = styled.div`
  overflow: hidden;
`;

export const animationAutoScroll = keyframes`
  100% {
    transform: translateX(-100%);
  }
`;
